import { validateToken } from 'src/services/userServicer';
import { clearUserDataCache } from './getUserInfo';
import socketService from './socketService';

let DOMAIN = process.env.REACT_APP_DOMAIN;
let DCC_URL = process.env.REACT_APP_URL_DCC;
const MAX_COOKIE_SIZE = 4000;

/** R-WAPT04: Token in memory only; never in JS-accessible cookies (backend sets HttpOnly cookies). */
let inMemoryToken: string | null = null;

async function loadConfig() {
  // DOMAIN and DCC_URL are read directly from .env (REACT_APP_* variables).
}

loadConfig().then(() => {
});






/**
 * Clear all cookies visible to JavaScript (e.g. csrfToken).
 * HttpOnly auth cookies are cleared by the backend on logout response.
 */
function clearAllCookies() {
  if (typeof document === 'undefined') return;
  const cookies = document.cookie.split('; ');
  for (const cookie of cookies) {
    const name = cookie.split('=')[0].trim();
    if (name) {
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
    }
  }
}

/**
 * Clears token from memory, user data cache, and client-visible cookies (backend clears HttpOnly cookies on logout).
 */
export function clearAuthToken() {
  inMemoryToken = null;
  clearUserDataCache();
  clearAllCookies();
  // Otherwise the next user to log in in this tab inherits this user's socket.
  socketService.disconnect();
}

/**
 * Validates JWT token.
 */
export async function isValidToken(token: string): Promise<boolean> {
  try {
   

    const response = await validateToken(token);

    if (response.success) {
      return true;
    }

    return false;
  } catch (error) {
    console.error("Invalid token:", error);
    return false;
  }
}

/**
 * Redirects user to login page if not authenticated.
 */
export function redirectToLogin() {
  if (typeof window !== "undefined") {
    window.location.href = DCC_URL + "/login";
  }
}

/**
 * Splits a long string into smaller parts.
 */
function splitString(str: string, size: number): string[] {
  const result: string[] = [];
  for (let i = 0; i < str.length; i += size) {
    result.push(str.substring(i, i + size));
  }
  return result;
}

/**
 * Helper to get a cookie value by name.
 */
function getCookie(name: string): any {
  const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`));
  return match ? match[2] : null;
}
